import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthPageComponent } from './page/auth-page/auth-page.component';
import { SearchToolComponent } from './page/search-tool/search-tool.component';
import { HomePageComponent } from './page/request/home-page/home-page.component';
import { ForgotPasswordComponent } from './page/forgot-password/forgot-password.component';
import { RequestPageComponent } from './page/request/request-page/request-page.component';
import { CmdbRegisterPageComponent } from './page/cmdb/cmdb-register-page/cmdb-register-page.component';
import { CmdbDashboardComponent } from './page/cmdb/cmdb-dashboard/cmdb-dashboard.component';
import { KnowledgeBasePageReworkComponent } from './page/knowledge-base/knowledge-base-page-rework/knowledge-base-page-rework.component';
import { KnowledgeArchivePageComponent } from './page/knowledge-base/knowledge-archive-page/knowledge-archive-page.component';
import { RegisterPageComponent } from './page/register-page/register-page.component';
import { CockpitPageComponent } from './page/cockpit/cockpit-page/cockpit-page.component';
import { CockpitEditComponent } from './page/cockpit/cockpit-edit/cockpit-edit.component';
import { ErrorPageComponent } from './page/error-page/error-page.component';
import { CmdbReportDownloadComponent } from './page/report/cmdb-report-download/cmdb-report-download.component';
import { StockPageComponent } from './page/stock/stock-page/stock-page.component';
import { CmdbQrcodeComponent } from './page/cmdb/cmdb-qrcode/cmdb-qrcode.component';
import { CmdbPrintQrcodeComponent } from './page/cmdb/cmdb-print-qrcode/cmdb-print-qrcode.component';
import { WelcomePageComponent } from './page/welcome-page/welcome-page.component';
import { BlankPageTemplateComponent } from './page/blank-page-template/blank-page-template.component';
import { AuthGuardService } from './util/guards/auth-guard.service';
import { PermissionGuardService } from './util/guards/permission-guard.service';
import { UserModalComponent } from './page_component/user-modal/user-modal.component';
import { RequestSatisfactionComponent } from './page_component/request-satisfaction/request-satisfaction.component';
import { RequestTaskComponent } from './page_component/request-task/request-task.component';
import { ReportHubComponent } from './page/report/report-hub/report-hub.component';
import { VersionPageComponent } from './page/version/version-page.component';
import { StockInfoPageComponent } from './page/stock/stock-info-page/stock-info-page.component';
import { NotificationPageComponent } from './page/notification-page/notification-page.component';
import { CmdbHomeScreenComponent } from './page/cmdb/cmdb-home-screen/cmdb-home-screen.component';
import { CmdbDigitalTermComponent } from './page/cmdb/cmdb-digital-term/cmdb-digital-term.component';
import { ChecklistHomePageComponent } from './page/checklist/checklist-home-page/checklist-home-page.component';
import { ChecklistRegisterPageComponent } from './page/checklist/checklist-register-page/checklist-register-page.component';
import { ChecklistExecutionComponent } from './page/checklist/checklist-execution/checklist-execution.component';
import { ChecklistExecutionMapComponent } from './page/checklist/checklist-execution-map/checklist-execution-map.component';
import { MyAssetComponent } from './page/my-asset/my-asset.component';
import { InconsistenciesComponent } from './page/my-asset/inconsistencies/inconsistencies.component';
import { InconsistenciesListComponent } from './page/my-asset/inconsistencies-list/inconsistencies-list.component';
import { EquipmentHistoryReportComponent } from './page/report/equipment-history-report/equipment-history-report.component';

const routes: Routes = [
	{ path: '', redirectTo: 'login', pathMatch: 'full' },

	{
		path: 'login',
		component: AuthPageComponent,
		canActivate: [AuthGuardService],
		data: { rules: ['noLogin', 'noMenu'] },
	},
	{
		path: 'login/:customerName',
		component: AuthPageComponent,
		canActivate: [AuthGuardService],
		data: { rules: ['noLogin', 'noMenu'] },
	},
	{
		path: 'passwordReset/:token',
		component: ForgotPasswordComponent,
		canActivate: [AuthGuardService],
		data: { rules: ['noLogin', 'noMenu'] },
	},

	{
		path: 'home',
		component: WelcomePageComponent,
		canActivate: [AuthGuardService],
	},

	{
		path: 'request',
		component: HomePageComponent,
		canActivate: [AuthGuardService, PermissionGuardService],
		data: { roles: ['access_request'], analystOnly: false, showCustomerDropdown: false },
	},
	{
		path: 'request/kb/:idKb',
		component: HomePageComponent,
		canActivate: [AuthGuardService, PermissionGuardService],
		data: { roles: ['access_request'], analystOnly: false, showCustomerDropdown: false },
	},
	{
		path: 'request/:idRequest',
		component: RequestPageComponent,
		canActivate: [AuthGuardService, PermissionGuardService],
		data: { roles: ['access_request'], analystOnly: false, showCustomerDropdown: false },
	},

	{
		path: 'search/:searchText',
		canActivate: [AuthGuardService],
		component: SearchToolComponent,
	},

	{
		path: 'cockpit',
		component: CockpitPageComponent,
		canActivate: [AuthGuardService, PermissionGuardService],
		data: { roles: ['access_cockpit'] },
	},
	{
		path: 'cockpit/edit',
		component: CockpitEditComponent,
		canActivate: [AuthGuardService, PermissionGuardService],
		data: { roles: ['access_cockpit'] },
	},
	{
		path: 'cockpit/full',
		component: CockpitPageComponent,
		canActivate: [AuthGuardService, PermissionGuardService],
		data: { roles: ['access_cockpit'], rules: ['noMenu'] },
	},

	{
		path: 'report',
		component: ReportHubComponent,
		canActivate: [AuthGuardService],
		data: { roles: ['access_report'] },
	},

	{
		path: 'cmdbDigitalTerm/signature/:uuid',
		component: CmdbDigitalTermComponent,
		canActivate: [AuthGuardService],
		data: { rules: ['noLogin', 'noMenu'] },
	},

	{
		path: 'cmdb/list',
		component: CmdbHomeScreenComponent,
		canActivate: [AuthGuardService, PermissionGuardService],
		data: { roles: ['access_cmdb'], analystOnly: true },
	},
	{
		path: 'cmdb/dashboard',
		component: CmdbDashboardComponent,
		canActivate: [AuthGuardService, PermissionGuardService],
		data: { roles: ['access_cmdb'], analystOnly: true },
	},
	{
		path: 'cmdb/equipment-history',
		component: EquipmentHistoryReportComponent,
		canActivate: [AuthGuardService, PermissionGuardService],
		data: { roles: ['access_cmdb'], analystOnly: true },
	},
	{
		path: 'cmdb/new',
		component: CmdbRegisterPageComponent,
		canActivate: [AuthGuardService, PermissionGuardService],
		data: { roles: ['access_cmdb', 'cmdb_inserir'], analystOnly: true },
	},
	{
		path: 'cmdb/:idCi/edit',
		component: CmdbRegisterPageComponent,
		canActivate: [AuthGuardService, PermissionGuardService],
		data: { roles: ['access_cmdb'], analystOnly: true },
	},
	{
		path: 'cmdb/:idCi/read',
		component: CmdbRegisterPageComponent,
		canActivate: [AuthGuardService, PermissionGuardService],
		data: { roles: ['access_cmdb'], analystOnly: true },
	},
	{
		path: 'cmdb/:idCi/edit/:tabView',
		component: CmdbRegisterPageComponent,
		canActivate: [AuthGuardService, PermissionGuardService],
		data: { roles: ['access_cmdb'], analystOnly: true },
	},
	{
		path: 'cmdb/:idCi/read/:tabView',
		component: CmdbRegisterPageComponent,
		canActivate: [AuthGuardService, PermissionGuardService],
		data: { roles: ['access_cmdb'], analystOnly: true },
	},
	{
		path: 'user/modal/:idUser',
		component: UserModalComponent,
		canActivate: [AuthGuardService, PermissionGuardService],
		data: { roles: ['access_cmdb'], analystOnly: true },
	},

	{
		path: 'qrcode/cmdb/:searchParam',
		component: CmdbQrcodeComponent,
		canActivate: [AuthGuardService],
		data: { rules: ['noMenu'], analystOnly: true },
	},

	{
		path: 'stock',
		component: StockPageComponent,
		canActivate: [AuthGuardService, PermissionGuardService],
		data: { roles: ['access_stock', 'access_cmdb'], analystOnly: true },
	},
	{
		path: 'stock/user/:idUser',
		component: StockInfoPageComponent,
		canActivate: [AuthGuardService, PermissionGuardService],
		data: { roles: ['access_stock', 'access_cmdb'], analystOnly: true },
	},

	{
		path: 'knowledgebase',
		component: KnowledgeBasePageReworkComponent,
		canActivate: [AuthGuardService, PermissionGuardService],
		data: { roles: ['access_kb'], analystOnly: true },
	},
	{
		path: 'knowledgebase/:idKb',
		component: KnowledgeBasePageReworkComponent,
		canActivate: [AuthGuardService, PermissionGuardService],
		data: { roles: ['access_kb'], analystOnly: true },
	},
	{
		path: 'knowledgebase/read/:idKb',
		component: KnowledgeArchivePageComponent,
		canActivate: [AuthGuardService, PermissionGuardService],
		data: { roles: ['access_kb'], analystOnly: false },
	},
	{
		path: 'knowledgebase/open/:idKb',
		component: KnowledgeArchivePageComponent,
		canActivate: [AuthGuardService],
		data: { rules: ['noLogin', 'noMenu'] },
	},

	{
		path: 'register',
		component: RegisterPageComponent,
		canActivate: [AuthGuardService, PermissionGuardService],
		data: { roles: ['access_register'], analystOnly: true },
	},
	{
		path: 'register/:idParent',
		component: RegisterPageComponent,
		canActivate: [AuthGuardService, PermissionGuardService],
		data: { roles: ['access_register'], analystOnly: true },
	},
	{
		path: 'register/:idParent/:idChild',
		component: RegisterPageComponent,
		canActivate: [AuthGuardService, PermissionGuardService],
		data: { roles: ['access_register'], analystOnly: true },
	},

	{
		path: 'report/cmdb/download',
		component: CmdbReportDownloadComponent,
		canActivate: [AuthGuardService],
		data: { rules: ['noLogin', 'noMenu'] },
	},

	{
		path: 'print/cmdb/qrcode',
		component: CmdbPrintQrcodeComponent,
		canActivate: [AuthGuardService, PermissionGuardService],
		data: { roles: ['access_cmdb'], rules: ['noMenu'], analystOnly: true },
	},
	{
		path: 'print/cmdb/barcode',
		component: CmdbPrintQrcodeComponent,
		canActivate: [AuthGuardService, PermissionGuardService],
		data: { roles: ['access_cmdb'], rules: ['noMenu'], analystOnly: true },
	},

	{
		path: 'test',
		component: BlankPageTemplateComponent,
		canActivate: [AuthGuardService],
	},

	{
		path: 'satisfaction/request/:requestId',
		component: RequestSatisfactionComponent,
		canActivate: [AuthGuardService],
		data: { rules: ['noLogin', 'noMenu'] },
	},
	{
		path: 'task/request/:requestId',
		component: RequestTaskComponent,
		canActivate: [AuthGuardService],
		data: { rules: ['noLogin', 'noMenu'] },
	},

	{
		path: 'checklist',
		component: ChecklistHomePageComponent,
		canActivate: [AuthGuardService, PermissionGuardService],
		data: { roles: ['access_checklist'], analystOnly: true },
	},
	{
		path: 'checklist/new',
		component: ChecklistRegisterPageComponent,
		canActivate: [AuthGuardService, PermissionGuardService],
		data: { roles: ['access_checklist'], analystOnly: true },
	},
	{
		path: 'checklist/map',
		component: ChecklistExecutionMapComponent,
		canActivate: [AuthGuardService, PermissionGuardService],
		data: { roles: ['access_checklist'], analystOnly: true },
	},
	{
		path: 'checklist/edit/:idChecklist',
		component: ChecklistRegisterPageComponent,
		canActivate: [AuthGuardService, PermissionGuardService],
		data: { roles: ['access_checklist'], analystOnly: true },
	},
	{
		path: 'checklist/execute/:idChecklist',
		component: ChecklistExecutionComponent,
		canActivate: [AuthGuardService, PermissionGuardService],
		data: { roles: ['access_checklist'], analystOnly: true },
	},
	{
		path: 'myasset',
		loadChildren: () => import('./page/my-asset/my-asset.routes').then((m) => m.myAssetRoutes),
		canActivate: [AuthGuardService, PermissionGuardService],
		data: { roles: ['access_myasset'] },
	},
	{
		path: 'notification',
		component: NotificationPageComponent,
		canActivate: [AuthGuardService, PermissionGuardService],
		data: { roles: ['access_request'], analystOnly: false },
	},

	{
		path: 'users',
		loadChildren: () => import('./page/user-management/user-management.routes').then((m) => m.userManagementRoutes),
		canActivate: [AuthGuardService, PermissionGuardService],
		data: { roles: ['access_users'] },
	},
	{
		path: 'version',
		component: VersionPageComponent,
		canActivate: [AuthGuardService],
		data: { rules: ['noLogin', 'noMenu'] },
	},
	{
		path: '**',
		component: ErrorPageComponent,
		canActivate: [AuthGuardService],
		data: { rules: ['noLogin', 'noMenu', 'noRoute'] },
	},
];

@NgModule({
	imports: [RouterModule.forRoot(routes)],
	exports: [RouterModule],
})
export class AppRoutingModule {}
